const LS_VOLUME_KEY = 'volume';
const LS_MUTED_KEY = 'muted';
import { longSlotRoll, shortSlotRoll, goodRolls, cursedRolls } from './assets/audio';

const audio = new Audio();

export function getVolume() {
  return Number.parseFloat(localStorage.getItem(LS_VOLUME_KEY) || '0.75');
}
export function setVolume(volume: number) {
  localStorage.setItem(LS_VOLUME_KEY, `${volume}`);
  audio.volume = volume;
}

export function isMuted() {
  return localStorage.getItem(LS_MUTED_KEY) === 'true';
}
export function setIsMuted(mute: boolean) {
  localStorage.setItem(LS_MUTED_KEY, `${mute}`);
  if (mute) {
    audio.volume = 0;
  } else {
    audio.volume = getVolume();
  }
}

export function playSound(src: string): Promise<void> {
  return new Promise((resolve) => {
    audio.src = src;
    audio.addEventListener('ended', () => {
      resolve();
    });
    audio.play();
  });
}

export function playGameRollSound(long = false) {
  return playSound(long ? longSlotRoll : shortSlotRoll);
}

function getRandom<T>(list: T[]): T {
  const index = Math.floor(list.length * Math.random());
  return list[index];
}

export function playGoodRollSound() {
  return playSound(getRandom(goodRolls));
}
export function playCursedRollSound() {
  return playSound(getRandom(cursedRolls));
}
